<template>
  <div class="home h-100">
    <NavbarMain />
    <div class="row h-100 m-0">
      <div class="col-xl-auto h-100 p-0 col-sm-12 h-sm-auto">
        <NavbarAdmin />
      </div>
      <div class="col">
        <h4 class="text-center py-3">
          {{ oldSpec.name }} [Especificacion]
          <span
            :class="`badge badge-success mr-1 ${
              oldSpec.product ? '' : 'd-none'
            }`"
            >Producto</span
          >
          <span
            :class="`badge badge-warning ${oldSpec.service ? '' : 'd-none'}`"
            >Servicio</span
          >
        </h4>
        <div class="container">
          <div class="form-group">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="spec.name" />
          </div>

          <div class="form-group">
            <label>Tipo</label>
            <select class="form-control" v-model="spec.selectable">
              <option :value="false">Información (Texto)</option>
              <option :value="true">Seleccionable (Opciones)</option>
            </select>
          </div>

          <div class="form-group">
            <label>Para</label>
            <select class="form-control" v-model="typeOfPS">
              <option :value="0">Producto</option>
              <option :value="1">Servicio</option>
              <option :value="2">Ambos</option>
            </select>
          </div>

          <span class="btn btn-treid btn-block" @click="handleSend()"
            >guardar cambios</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../tools/Api2";
import NavbarMain from "@/components/NavbarMain.vue";
import NavbarAdmin from "@/components/NavbarAdmin.vue";
import { mapState } from "vuex";
export default {
  name: "Spec",
  data() {
    return {
      oldSpec: {
        name: this.$route.params.title,
        product: false,
        selectable: false,
        service: false
      },
      spec: {
        name: this.$route.params.title,
        product: false,
        selectable: false,
        service: false
      },
      typeOfPS: 0
    };
  },
  components: {
    NavbarMain,
    NavbarAdmin
  },
  computed: {
    ...mapState(["auth"])
  },
  methods: {
    reloadFormCategory() {
      Api("form-category").get(this.$route.params.id).then(res => {
        this.spec = res.formCategory;
        this.oldSpec = {...res.formCategory};
        this.category = res.formCategory.category;
        if (res.formCategory.product && res.formCategory.service) this.typeOfPS = 2;
        else if (res.formCategory.product && !res.formCategory.service) this.typeOfPS = 0;
        else this.typeOfPS = 1;
      })
    },
    handleSend() {
      if(!this.spec.name)
        return;

      Api("form-category").patch(this.$route.params.id, {
        name: this.spec.name,
        selectable: this.spec.selectable,
        service: this.typeOfPS > 0,
        product: this.typeOfPS != 1
      }).then(() => this.$router.push("/admin/specs"))

    }
  },
  created: async function() {
    this.reloadFormCategory();
  }
};
</script>